// customerData for the brij.registrationInitiation dataLayer event. Same keys
// and same field rules as brij.registrationSubmission (ProductDetails
// fireRegistrationSubmissionEvent), limited to what is known when a
// registration starts: the signed-in email, the stored profile and the consent
// state. Receipt and form answers only exist later, at submission.
import { normalizePhoneNumber } from './normalizePhoneNumber';
import buildCustomerAddressData from './buildCustomerAddressData';

export type RegistrationInitiationCustomer = {
  // The signed-in user's own profile (personalDetails.profile). Leave it out
  // when it is not loaded yet or belongs to someone else.
  profile?: any;
  brandId?: string;
  // The consent state submission falls back to when the profile holds no
  // permission for the brand.
  emailConsent?: boolean | null;
  smsConsent?: boolean | null;
};

const buildRegistrationInitiationCustomerData = (
  email: unknown,
  customer?: RegistrationInitiationCustomer
): Record<string, any> => {
  const customerData: Record<string, any> = {};
  if (typeof email === 'string' && email.includes('@')) {
    customerData.customerEmail = email;
  }

  const profile =
    customer?.profile && typeof customer.profile === 'object'
      ? customer.profile
      : null;
  const userPermissions: any =
    (customer?.brandId && profile?.userPermissions?.[customer.brandId]) || {};

  const customerPhoneNumber = normalizePhoneNumber(profile?.phoneNumber);
  if (customerPhoneNumber) {
    customerData.customerPhoneNumber = customerPhoneNumber;
  }
  if (profile?.firstName) customerData.customerFirstName = profile.firstName;
  if (profile?.lastName) customerData.customerLastName = profile.lastName;

  const customerEmailConsent =
    userPermissions?.emailConsent?.allowed ?? customer?.emailConsent;
  if (customerEmailConsent !== null && customerEmailConsent !== undefined) {
    customerData.customerEmailConsent = customerEmailConsent;
  }
  const customerSMSSingleConsent =
    userPermissions?.smsSingleOptIn?.allowed ?? customer?.smsConsent;
  if (
    customerSMSSingleConsent !== null &&
    customerSMSSingleConsent !== undefined
  ) {
    customerData.customerSMSSingleConsent = customerSMSSingleConsent;
  }

  Object.assign(
    customerData,
    buildCustomerAddressData({ profileAddress: profile?.address })
  );

  return customerData;
};

export default buildRegistrationInitiationCustomerData;
